// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.
import { Environment } from './environment.d';

export const environment: Environment = {
  production: false,
  env: 'qc',
  apiEndpoint: 'https://lmsuat.gc-solutions.net/TVSCreditUat/AppService/api/',
  apiBaseUrl: 'https://lmsuat.gc-solutions.net/TVSCreditUat/AppService/',  
  searchApiEndpoint: 'https://lmsuatservices.gc-solutions.net/product80/rest/v1/tvscredit/',
  title: 'Siksha',
  saveLogs: false,
  storageLoginKey: 'LoginDetails',
  storageResourcesKey: 'StringResources',
  storageSearchApiKey: 'searchapi',
  hostName: 'tvscredit',
  lmsBaseUrl: 'https://lmsuat.gc-solutions.net/TVSCreditUat/',
  //lmsBaseUrl: 'https://lmsuat.gc-solutions.net/TVSCreditUat/',
  pageSize: 10,
  sessionTimeOut: 1200,
  videolibraryapiurl: 'https://lmsuatservices.gc-solutions.net/video80/rest/v2/tvscredit',
  videoLibraryThumbnailApiUrl: 'https://lmsuatservices.gc-solutions.net/video80/rest/v2/tvscredit/thumbnail?videokey=',
  dashboardViewerUrl: 'https://lmsuatservices.gc-solutions.net/olap80/Viewer.aspx?HostName=tvscredit',
  // auth server(keycloak)
  keycloakConfigOptions:  {
		// url: 'http://localhost:8080',
		// realm: 'example',
		// clientId: 'cordova',
		url: 'https://lmsuatservices.gc-solutions.net/auth/',
		realm: 'TVSCredit',
		clientId: 'learner-web',
		// realm: 'lmsgrowth',
		// clientId: 'learnerweb',
		enableLogging: true,
	},
	keycloakInitOptions : {
		onLoad: 'login-required',
		responseMode: 'query',
		//redirectUri: 'https://localhost:4200/index.html?corporateID=1&selectedCultureID=en-US&selectedUserRoleID=3&isLearnerSwitch=true',
		redirectUri: 'https://lmsuat.gc-solutions.net/TVSCreditUat/Learner',
    checkLoginIframe: false
		//redirectUri: 'http://localhost/WizdomGitBranch/learner/',
	},
  notificationInterval:60000
};
